// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5309acc1","732":"5f1fb00d","977":"105d6a31"}[chunkId] + ".chunk.js";
};